import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../../libs/bulma.min.css';
import '../MembersList.css';
import '../QueuesForm.css';

import PbxContext from '../../../../context/PbxContext';
import { accessLocalStorage, valuesAnalyze, changeViewForms, exportSelectQueueMemberById, exportUpdateQueueMember, exportSelectAllQueues } from '../../../../services';
import Loading from '../../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faUsers } from '@fortawesome/free-solid-svg-icons';

function MemberQueuesById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [queues, setQueues] = useState([]);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [member, setMember] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchMember = async (idtenant) => {
    try {
      const membersList = await exportSelectQueueMemberById({ id: itemsSelectedToEdit });

      if (!membersList || !Array.isArray(membersList) || membersList.length <= 0) {
        return history.push('/config/fila/membros/lista');
      }

      const memberData = membersList[0];
      
      const validateState = {};
      Object.keys(memberData).forEach((item) => {
        if (memberData[item] !== null && memberData[item] !== undefined) {
          validateState[item] = true;
        }
      });
      setValidate(validateState);

      const fetchQueues = await exportSelectAllQueues();
      if (!fetchQueues || fetchQueues.length <= 0) {
        setQueues(['Necessário criar as filas primeiro']);
      } else {
        const queuesEdited = idtenant.includes('vgs') 
          ? fetchQueues 
          : fetchQueues.filter((queue) => idtenant.includes(queue.accountcodequeue));
        setQueues(queuesEdited);
      }

      console.log(memberData);
      
      // Normalizar os dados para o formato esperado pelo formulário
      const normalizedData = {
        ...memberData,
        // Garantir que memberOrder seja mapeado para memberorder
        memberorder: memberData.memberOrder !== undefined ? memberData.memberOrder : (memberData.memberorder !== undefined ? memberData.memberorder : null),
        // Garantir que reasonPaused seja mapeado para reasonpaused
        reasonpaused: memberData.reasonPaused !== undefined ? memberData.reasonPaused : (memberData.reasonpaused !== undefined ? memberData.reasonpaused : null),
        // Garantir que queueName seja mapeado para queuename
        queuename: memberData.queueName !== undefined ? memberData.queueName : (memberData.queuename !== undefined ? memberData.queuename : null)
      };
      
      setValues(normalizedData);
      setMember(memberData);
      setLoading(false);
      return memberData;
    } catch (error) {
      setLoading(false);
      return null;
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    await fetchMember(idtenant);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'queuename' || name === 'membername') {
      const checkValueIsNumber = isTripleChar(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'penalty' || name === 'paused' || name === 'wrapuptime' || name === 'memberorder') {
      const checkValueIsCharacters = checkNumber(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }

    if(name === 'reasonpaused' || name === 'ringinuse') {
      return true;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => ({ ...prevState, [name]: itemStatus === undefined ? true : itemStatus }));
    setValues((prevState) => ({ ...prevState, [name]: value }));

    const updatedValidate = { ...validate, [name]: itemStatus === undefined ? true : itemStatus };
    if (Object.keys(updatedValidate).length >= 4) {
      const hasInvalid = Object.values(updatedValidate).includes(false);
      setDisable(hasInvalid);
    }
  };

  const sendDataMemberUpdate = async () => {
    // Normalizar os campos para o formato esperado pelo backend
    // Tratar member_order: aceitar 0 como valor válido
    let memberOrderValue = null;
    if (values.memberorder !== undefined && values.memberorder !== null && values.memberorder !== '') {
      memberOrderValue = Number(values.memberorder);
    } else if (values.memberOrder !== undefined && values.memberOrder !== null && values.memberOrder !== '') {
      memberOrderValue = Number(values.memberOrder);
    }
    
    const updateData = {
      ...values,
      uniqueid: itemsSelectedToEdit,
      reason_paused: values.reasonpaused || values.reasonPaused || values.reason_paused || null,
      member_order: memberOrderValue !== null && !isNaN(memberOrderValue) ? memberOrderValue : null
    };
    
    // Remover campos que não devem ser enviados
    delete updateData.memberOrder;
    delete updateData.reasonPaused;
    
    const sendDataUpdate = await exportUpdateQueueMember(updateData);
    
    if (sendDataUpdate) {
      toggleIsHidden('#alert-create-endpoints');
      setTimeout(() => {
        history.push('/config/fila/membros/lista');
      }, 2000);
    }
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, []);

  return (
    <div className="members-list-container">
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="members-list-header">
            <div className="members-list-title-wrapper">
              <svg className="members-list-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h1 className="members-list-title">Alterar Membro do Grupo</h1>
                <p className="members-list-subtitle">Edite as informações do membro</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-create-endpoints" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Membro do grupo alterado com sucesso!
              </div>
            </div>
          </div>

          <div className="member-endpoint-info">
            Ramal: <strong>{values.endpoint || member.endpoint || '-'}</strong>
          </div>

          <div className="form-card">
            <form name="create-form" id="create-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-field form-field-medium">
                  <label className="form-label">Fila</label>
                  <div className="form-control">
                    <select className="form-select" name="queueName" defaultValue={ values.queuename } onChange={(e) => handleChangeValues(e.target)} disabled={ true }>
                      <option value="">Selecione</option>
                      {Array.isArray(queues) && queues.map((queue) => {
                        if (typeof queue === 'string') return null;
                        return (
                          <option value={values.queuename || member.queuename || ''} key={ values.uniqueid } >
                            { queue.namequeue }
                          </option>
                        );
                      })}
                    </select>
                    <p name="queueName-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-medium">
                  <label className="form-label">Nome do Atendente/Membro</label>
                  <div className="form-control">
                    <input className="form-input" name="membername" type="text" defaultValue={values.membername || member.membername || ''} onChange={(e) => handleChangeValues(e.target)} />
                    <p name="membername-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-small">
                  <label className="form-label">Penalidade</label>
                  <div className="form-control">
                    <input className="form-input" name="penalty" defaultValue={ values.penalty } type="number" onChange={(e) => handleChangeValues(e.target)} />
                    <p name="penalty-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-small">
                  <label className="form-label">Pausa</label>
                  <div className="form-control">
                    <select className="form-select" name="paused" defaultValue={ values.paused } onChange={(e) => handleChangeValues(e.target)}>
                      <option value="">Selecione</option>
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                    <p name="paused-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field form-field-small">
                  <label className="form-label">Tempo de Descanso</label>
                  <div className="form-control">
                    <input className="form-input" name="wrapuptime" type="number" defaultValue={ values.wrapuptime } onChange={(e) => handleChangeValues(e.target)} placeholder="Segundos" min="0" />
                    <p name="wrapuptime-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-small">
                  <label className="form-label">Toca em Uso</label>
                  <div className="form-control">
                    <select className="form-select" name="ringinuse" defaultValue={ values.ringinuse } onChange={(e) => handleChangeValues(e.target)}>
                      <option value="">Selecione</option>
                      <option value="yes">Sim</option>
                      <option value="no">Não</option>
                    </select>
                    <p name="ringinuse-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-medium">
                  <label className="form-label">Motivo da Pausa</label>
                  <div className="form-control">
                    <input className="form-input" name="reason_paused" type="text" defaultValue={ values.reasonpaused } onChange={(e) => handleChangeValues(e.target)} placeholder="Motivo da pausa (opcional)" />
                    <p name="reason_paused-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>

                <div className="form-field form-field-small">
                  <label className="form-label">Ordem do Membro</label>
                  <div className="form-control">
                    <input className="form-input" name="memberorder" type="number" defaultValue={ values.memberOrder || values.memberorder || member.memberOrder || member.memberorder || '' } onChange={(e) => handleChangeValues(e.target)} placeholder="0" min="0" />
                    <p name="memberorder-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</p>
                  </div>
                </div>
              </div>
            </form>

            <div className="form-actions">
              <button className="btn-submit" type="submit" onClick={() => sendDataMemberUpdate()} disabled={disable}>
                <FontAwesomeIcon icon={faSave} />
                <span>Atualizar</span>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default MemberQueuesById;
